import React, { useEffect } from "react";
import { css } from "emotion";
import { boxStyles } from "../styles/theme";
import Sidebar from "./Sidebar";
import MobileMenu from "./MobileMenu";

const PageTemplate = ({
  mobileHeader,
  children,
  centered,
  fullWidth,
  sidebarTitle,
  sidebarSubtitle,
  title = "Home",
  centeredVertical
}) => {
  useEffect(() => {
    document.title = `${title} - Spotlight`;
  });

  return (
    <div className={container}>
      <div className="mobile">{mobileHeader}</div>
      <div className="sidebar">
        <Sidebar title={sidebarTitle} subtitle={sidebarSubtitle} />
      </div>
      <div
        className={
          "main" +
          (centered ? " center" : "") +
          (fullWidth ? " full-width" : "") +
          (centeredVertical ? " center-vertical" : "")
        }
      >
        <div className="content">{children}</div>
      </div>
      <MobileMenu />
    </div>
  );
};

export default PageTemplate;

const container = css`
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
  .sidebar {
    display: none;
  }
  .main {
    display: flex;
    flex-direction: column;
    flex: 1;

    &.center {
      flex: 1;
      align-items: center;
      padding-bottom: 40px;
    }

    .content {
      max-width: 900px;
      width: 100%;
    }
    
    &.center-vertical {
      .content {
        height: 100%;
      }
    }

    &.full-width {
      padding-left: 0;
      padding-right: 0;

      .content {
        max-width: none;

        .title-with-back-button {
          padding-left: 30px;
          padding-top: 30px;
        }
      }
    }
  }

  @media screen and (min-width: ${boxStyles.desktopBreak}) {
    flex-direction: row;
    justify-content: flex-start;
    .mobile {
      display: none;
    }
    .sidebar {
      display: flex;
      width: 320px;
    }
    .main {
      padding: 20px 0 20px 20px;

      &.center {
        padding: 20px 20px 80px 20px;
      }

      &.full-width {
        padding-left: 0;
        padding-right: 0;

        .content {
          max-width: none;

          .title-with-back-button {
            padding-left: 30px;
            padding-top: 30px;
            margin-bottom: 30px;
          }
        }
      }
    }
  }
`;
